/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const Drawer = (props: { className?: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <rect
      id="Rectangle_3306"
      data-name="Rectangle 3306"
      width="18"
      height="18"
      transform="translate(18.51 11.6)"
      fill="currentColor"
    />
    <g
      id="Groupe_de_masques_7"
      data-name="Groupe de masques 7"
      transform="translate(-18.51 -11.6)"
      clipPath="url(#clip-path)"
    >
      <g id="file-tray-full-outline" transform="translate(17.225 10.314)">
        <path
          id="Tracé_6375"
          data-name="Tracé 6375"
          d="M15.429,3.214H5.143A1.816,1.816,0,0,0,3.214,4.821L1.929,10.929v4.5a1.934,1.934,0,0,0,1.929,1.929H16.714a1.934,1.934,0,0,0,1.929-1.929v-4.5L17.357,4.821A1.811,1.811,0,0,0,15.429,3.214Z"
          fill="none"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="1.286"
        />
        <path
          id="Tracé_6376"
          data-name="Tracé 6376"
          d="M7.714,10.929a2.571,2.571,0,0,0,5.143,0"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.286"
        />
        <line
          id="Ligne_302"
          data-name="Ligne 302"
          x2="5.786"
          transform="translate(1.929 10.929)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.286"
        />
        <line
          id="Ligne_303"
          data-name="Ligne 303"
          x2="5.786"
          transform="translate(12.857 10.929)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.286"
        />
        <line
          id="Ligne_304"
          data-name="Ligne 304"
          x2="9"
          transform="translate(5.786 5.786)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.286"
        />
        <line
          id="Ligne_305"
          data-name="Ligne 305"
          x2="10.286"
          transform="translate(5.143 8.357)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.286"
        />
      </g>
    </g>
  </svg>
);

export { Drawer };
